import type { SavedPaymentMethod } from 'src/app/pages/promote/shared/types';
import type { PaymentType } from 'src/app/shared/utils/payments';

import type { PromotePageMainDataQuery } from '../getPromotePageMainData.graphql';

export type PaymentMethods = NonNullable<
	NonNullable<PromotePageMainDataQuery['session']['userProtectedData']>['paymentMethods']
>[0];

export function normalizeSavedPaymentMethods(
	paymentMethods: readonly PaymentMethods[] | undefined,
): SavedPaymentMethod[] | undefined {
	if (!paymentMethods) return undefined;
	return (
		paymentMethods
			// Remove any saved payment methods that can't be used
			.filter(
				(paymentMethod: PaymentMethods) => paymentMethod.settings.supportsOneTimeCharges, // This field being set is another condition that makes it valid for use.
			)
			// Add a type field to each one for use throughout the UI logic, for tracking events, etc
			.map((paymentMethod: PaymentMethods) => {
				return {
					...paymentMethod,
					type: {
						PaymentMethodCreditCard: 'creditCard',
						PaymentMethodPayPal: 'paypal',
						PaymentMethodSepa: 'sepa',
						PaymentMethodVenmo: 'venmo',
						PaymentMethodLink: 'link',
					}[paymentMethod.__typename] as PaymentType,
				};
			})
	);
}
